// Pre-boss rest node — fully heals the player's team.

import type { Scene } from "../engine/scene/SceneManager";
import type { Game } from "../game/Game";
import type { MapNode } from "../map/CampaignMap";
import { MapScene } from "./MapScene";
import { MainMenuScene } from "./MainMenuScene";

export class HealScene implements Scene {
  private root: HTMLDivElement;

  constructor(
    private game: Game,
    private _node: MapNode,
  ) {
    this.root = document.createElement("div");
    this.root.className = "reward-screen";
  }

  enter(): void {
    const state = this.game.runState;
    if (!state) {
      this.game.sceneManager.transition(new MainMenuScene(this.game));
      return;
    }

    state.healFull();

    const title = document.createElement("div");
    title.className = "reward-title";
    title.textContent = "REST";
    this.root.appendChild(title);

    const msg = document.createElement("div");
    msg.style.cssText = "color:var(--accent-hot);font-size:13px;margin-bottom:4px;";
    msg.textContent = "Your team has been fully healed.";
    this.root.appendChild(msg);

    const sub = document.createElement("div");
    sub.style.cssText = "color:rgba(180,190,210,0.5);font-size:11px;margin-bottom:12px;";
    sub.textContent = "The boss awaits.";
    this.root.appendChild(sub);

    const btn = document.createElement("button");
    btn.className = "btn";
    btn.style.marginTop = "8px";
    btn.textContent = "CONTINUE";
    btn.addEventListener("click", () => {
      this.game.sceneManager.transition(new MapScene(this.game));
    });
    this.root.appendChild(btn);

    this.game.sceneRoot.appendChild(this.root);
  }

  exit(): void {
    this.root.remove();
  }

  update(_dt: number): void {}
  render(_ctx: CanvasRenderingContext2D): void {}
}
